import { render, staticRenderFns } from "./ques6.vue?vue&type=template&id=06575c07"
import script from "./ques6.vue?vue&type=script&lang=js"
export * from "./ques6.vue?vue&type=script&lang=js"
import style0 from "./ques6.vue?vue&type=style&index=0&id=06575c07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports